import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './Hero.css';

const Hero = () => {
    return (
        <section id="home" className="hero-section">
            <div className="hero-background">
                <div className="hero-particles"></div>
            </div>
            <Container>
                <Row className="align-items-center min-vh-100">
                    <Col lg={6} className="hero-content">
                        <div className="hero-badge">
                            <i className="fas fa-award me-2"></i>
                            Cabinet dentaire d'excellence depuis 2010
                        </div>
                        <h1 className="hero-title" style={{ color: 'white' }}>
                            Votre sourire, 
                            <span className="text-gradient"> notre expertise</span>
                        </h1>
                        <p className="hero-subtitle">
                            Découvrez l'excellence des soins dentaires avec notre équipe de spécialistes. 
                            Technologies de pointe, confort optimal et résultats exceptionnels.
                        </p>
                        <div className="hero-stats">
                            <div className="stat-item">
                                <div className="stat-number" style={{ color: 'white' }}>15+</div>
                                <div className="stat-label" style={{ color: 'white' }}>Années d'expérience</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-number" style={{ color: 'white' }}>5000+</div>
                                <div className="stat-label" style={{ color: 'white' }}>Patients satisfaits</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-number" style={{ color: 'white' }}>98%</div>
                                <div className="stat-label" style={{ color: 'white' }}>Taux de satisfaction</div>
                            </div>
                        </div>
                        <div className="hero-buttons">
                            <Button className="btn-primary-custom me-3">
                                <i className="fas fa-calendar-plus me-2"></i>
                                Prendre Rendez-vous
                            </Button>
                            <Button variant="outline-light" className="btn-outline-custom">
                                <i className="fas fa-play me-2"></i>
                                Voir la vidéo
                            </Button>
                        </div>
                    </Col>
                    <Col lg={6} className="hero-image">
                        <div className="hero-image-container">
                            <div className="floating-card card-1">
                                <i className="fas fa-shield-alt"></i>
                                <span>Sécurité garantie</span>
                            </div>
                            <div className="floating-card card-2">
                                <i className="fas fa-star"></i>
                                <span>5★ Excellence</span>
                            </div>
                            <div className="floating-card card-3">
                                <i className="fas fa-clock"></i>
                                <span>Disponible 24/7</span>
                            </div>
                            <div className="hero-mockup">
                                <div className="mockup-content">
                                    <i className="fas fa-tooth hero-tooth-icon"></i>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="hero-wave">
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M1200 120L0 16.48V0h1200v120z" fill="#fff"></path>
                </svg>
            </div>
        </section>
    );
};

export default Hero;